import { Map } from 'immutable';

import { isObject } from '../../../isObject';
import { aiGenerated } from './ai';

import { WAIT_FOR_SYNC } from '../../../../constants/shops';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import { VALUE } from '../../../../constants/product';
import { EMPTY } from '../../../../constants';
import ATTRIBUTE from '../../../../constants/attributes';

import actions from '../../../../actions';

export function photos({ channel, operation, preview, state }) {
  function reduceValue(result, value) {
    return result.push(
      isObject(value) && !Map.isMap(value)
        ? Map(value)
        : value
    );
  }

  switch (operation) {
    case OPERATIONS[channel].PHOTOS.ADD:
    case OPERATIONS[channel].PHOTOS.REPLACE: {
      return {
        actions: [actions.bulkEdit.setData({ waitForSync: WAIT_FOR_SYNC.FINISH })],
        payload: Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.PHOTOS, ATTRIBUTE.PHOTOS]).reduce(reduceValue, EMPTY.LIST),
        }),
      };
    }

    case OPERATIONS[channel].PHOTOS.ALT_TEXT: {
      return {
        payload: Map({
          type: OPERATIONS[channel].PHOTOS.UPDATE,
          value: Map({
            attributes: Map({ alt_text: preview.getIn([ATTRIBUTE.PHOTOS, VALUE], '') }),
            index: preview.getIn([ATTRIBUTE.PHOTOS, 'photo']),
          }),
        }),
      };
    }

    case OPERATIONS[channel].PHOTOS.ALT_TEXT_AI_GENERATED: {
      return aiGenerated({ attribute: ATTRIBUTE.PHOTOS, operation: OPERATIONS[channel].PHOTOS.UPDATE, preview, state });
    }

    case OPERATIONS[channel].PHOTOS.EDIT: {
      return {
        payload: preview.getIn([ATTRIBUTE.PHOTOS, 'operations']),
      };
    }

    default: {
      return {
        payload: Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.PHOTOS, ATTRIBUTE.PHOTOS]).reduce(reduceValue, EMPTY.LIST),
        }),
      };
    }
  }
}
